import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./plugin/i18n/i18n.js";
import store from "./store";

import dateFns from "date-fns";
import isBefore from "date-fns/is_before";

import VeeValidate, { Validator } from "vee-validate";
import ja from "vee-validate/dist/locale/ja";
import en from "vee-validate/dist/locale/en";

Vue.use(
  VeeValidate,
  // オプションでi18nを指定する
  {
    i18n,
    i18nRootKey: "validations",
    dictionary: { ja, en },
  }
);
Validator.localize("ja", ja);

Validator.extend("isFuture", {
  getMessage: () => {
    return `不正な値が入力されています`;
  },
  validate: (value) => {
    const dt = new Date();
    const formatedDt = dateFns.format(dt, "YYYY-MM-DD");
    return isBefore(value, formatedDt);
  },
});

Vue.config.productionTip = false;

/* インポートすると全体に効果が出てしまうため、登録解除する */
import ChartDataLabels from "chartjs-plugin-datalabels";
// eslint-disable-next-line no-undef
Chart.plugins.unregister(ChartDataLabels);

// エラーハンドラー
/*Vue.config.errorHandler = (err, vm, info) => {
  // eslint-disable-next-line no-console
  console.log(`Error: ${info}`, err);
  if (process.env.VUE_APP_SEND_ERROR === "on") {
    const addErrorMessage = firebase
      .functions()
      .httpsCallable("addErrorMessage");
    addErrorMessage({ messasge: info });
  }
  router.push({ name: "error" });
};
window.addEventListener("error", event => {
  // eslint-disable-next-line no-console
  console.log("Error EventListener", event.error);
  router.push({ name: "error" });
});
window.addEventListener("unhandledrejection", event => {
  // eslint-disable-next-line no-console
  console.log("unhandledrejection EventListener", event.reason);
  router.push({ name: "error" });
});*/

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount("#app");
